import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceCannedResponsesRoute: InvariantJiraRoute = {
	name: 'project-settings-customer-service-canned-responses',
	path: '/jira/servicedesk/projects/:projectKey/settings/canned-responses',
	exact: true,
};
